import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import './UsersRiskIndex.scss';
import WarnInfoList from "../../user/list/WarnInfoList";
import BlacklistInfoList from "../../user/list/BlacklistInfoList";
import UserDisputeIndex from "../../user/list/UsersDisputeIndex";


function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <Typography component="div">{children}</Typography>
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    backgroundColor: 'transparent',
    color: 'white',
    boxShadow: 'none',
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { data } = props.admin.tip;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`risk-users-tab-container ${classes.root}`}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label={`Warning Information${data&&data.user&&data.user.warnCount?'('+data.user.warnCount+')':''}`} {...a11yProps(0)}/>
          <Tab label="Restricting Users" {...a11yProps(1)} />
          <Tab label={`Dispute Orders${data&&data.user&&(data.user.disputeCount+data.user.reviewCount)?'('+(data.user.disputeCount+data.user.reviewCount)+')':''}`} {...a11yProps(2)} />

        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <WarnInfoList {...props}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <BlacklistInfoList {...props}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserDisputeIndex {...props}/>
      </TabPanel>

    </div>
  );
}
